import { name, tagLine } from '../info.ts'

export const title = (): string => `Socials · ${name} · ${tagLine}`
